import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { IconButton } from '@hvcgroep/design-system';

import trackNavigationClick from '../../../helpers/trackNavigationClick';

export interface NavigationViewMonthProps {
  currentDate: Date;
  updateDate: (date: Date) => void;
}

const TITLE_ID = 'waste-calendar-title';

const NavigationViewMonth: React.FC<NavigationViewMonthProps> = (props) => {
  const {
    currentDate = new Date(),
    updateDate,
  } = props;

  const { t } = useTranslation();

  const classNames = c('Navigation', 'Navigation--ViewMonth');
  const today = new Date();

  return (
    <nav className={classNames}>
      <IconButton
        icon="keyboard_arrow_left"
        disabled={currentDate.getFullYear() === today.getFullYear() && currentDate.getMonth() === 0}
        onClick={() => {
          const newDate = new Date(currentDate.setMonth(currentDate.getMonth() - 1));
          trackNavigationClick(t('waste_calendar.navigation.prev'), newDate);
          updateDate(newDate);
        }}
      >
        {t('waste_calendar.navigation.prev')}
      </IconButton>

      <h2 className="CalendarWidget__header__date mb-0" aria-live="polite" id={TITLE_ID}>
        {currentDate.toLocaleString('nl-NL', { month: 'long' })} <span>{currentDate.getFullYear()}</span>
      </h2>

      <IconButton
        icon="keyboard_arrow_right"
        disabled={currentDate.getFullYear() === today.getFullYear() + 1 && currentDate.getMonth() === 11}
        onClick={() => {
          const newDate = new Date(currentDate.setMonth(currentDate.getMonth() + 1));
          trackNavigationClick(t('waste_calendar.navigation.next'), newDate);
          updateDate(newDate);
        }}
      >
        {t('waste_calendar.navigation.next')}
      </IconButton>
    </nav>
  );
};

export default NavigationViewMonth;
